import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-074b5c9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  open: "",
  class: "popup popup--small js-popup is-opened"
}
const _hoisted_2 = { class: "popup__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "popup__content" }
const _hoisted_6 = {
  key: 1,
  class: "field-group",
  "data-group": "1"
}
const _hoisted_7 = { class: "field" }
const _hoisted_8 = {
  key: 2,
  class: "field-group",
  "data-group": "1"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = {
  key: 1,
  class: "field-group",
  "data-group": "1"
}
const _hoisted_11 = { class: "field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerSmall = _resolveComponent("LoadingSpinnerSmall")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.showSetupTariffsModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          class: "popup-overlay"
        }))
      : _createCommentVNode("", true),
    (_ctx.showSetupTariffsModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("header", null, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "popup__close js-popup-close",
                style: {"cursor":"pointer"}
              }, _hoisted_4)
            ], true)
          ]),
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["auth-steps js-auth-steps js-auth-step-1", { 'is-active': _ctx.setupStep === _ctx.SetupFlow.start }])
            }, [
              (_ctx.isLoadingModal)
                ? (_openBlock(), _createBlock(_component_LoadingSpinnerSmall, {
                    key: 0,
                    class: "report-loader"
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isLoadingModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToTariff('more_info'))),
                        class: "btn btn-blue",
                        style: {"cursor":"pointer"}
                      }, _toDisplayString(_ctx.$t("reports.more_info")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isLoadingModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsubscribe && _ctx.unsubscribe(...args))),
                        class: "btn btn-white",
                        style: {"cursor":"pointer"}
                      }, _toDisplayString(_ctx.$t("reports.deactivate")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["auth-steps js-auth-steps js-auth-step-2", { 'is-active': _ctx.setupStep === _ctx.SetupFlow.unsubbed }])
            }, [
              _createVNode(_component_i18n_t, {
                keypath: "reports.deactivated_text",
                tag: "div",
                class: "text--deactivated"
              }, {
                expiry_date: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tariffExpiryDate), 1)
                ]),
                _: 1
              }),
              (_ctx.isLoadingModal)
                ? (_openBlock(), _createBlock(_component_LoadingSpinnerSmall, {
                    key: 0,
                    class: "report-loader"
                  }))
                : _createCommentVNode("", true),
              (!_ctx.isLoadingModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reactivate && _ctx.reactivate(...args))),
                        class: "btn btn-blue",
                        style: {"cursor":"pointer"}
                      }, _toDisplayString(_ctx.$t("reports.reactivate_tariff")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}